export const STATUS_LABELS = {
  new: "New",
  started: "Started",
  in_process: "In Process",
  under_review: "Under Review",
  approved: "Approved",
  cancelled: "Cancelled",
};

const STATUS_STYLES = {
  new: "bg-blue-50 text-blue-700 border-blue-200",
  started: "bg-indigo-50 text-indigo-700 border-indigo-200",
  in_process: "bg-sky-50 text-sky-700 border-sky-200",
  under_review: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
};

const STATUS_DOTS = {
  new: "bg-blue-500",
  started: "bg-indigo-500",
  in_process: "bg-sky-500",
  under_review: "bg-amber-500",
  approved: "bg-emerald-500",
  cancelled: "bg-slate-400",
};

const PRIORITY_STYLES = {
  critical: "bg-rose-600 text-white",
  high: "bg-orange-500 text-white",
  medium: "bg-amber-400 text-slate-900",
  low: "bg-slate-200 text-slate-700",
};

export function StatusBadge({ status, overdue }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        data-testid={`task-status-badge-${status}`}
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLES[status] || STATUS_STYLES.new}`}
      >
        <span className={`h-1.5 w-1.5 rounded-full ${STATUS_DOTS[status] || STATUS_DOTS.new}`} />
        {STATUS_LABELS[status] || status}
      </span>
      {overdue && (
        <span data-testid="task-overdue-badge" className="inline-flex items-center rounded-full border border-rose-200 bg-rose-50 px-2.5 py-0.5 text-xs font-bold text-rose-700">
          Overdue
        </span>
      )}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <span
      data-testid={`task-priority-badge-${priority}`}
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs capitalize ${PRIORITY_STYLES[priority] || PRIORITY_STYLES.low}`}
    >
      {priority}
    </span>
  );
}

export function RoleBadge({ role }) {
  const styles = {
    owner: "bg-[#0B192C] text-white",
    admin: "bg-[#1E3A8A] text-white",
    manager: "bg-teal-700 text-white",
    employee: "bg-slate-200 text-slate-700",
  };
  const labels = { owner: "Owner", admin: "Admin", manager: "Manager", employee: "Employee" };
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold ${styles[role] || styles.employee}`}>
      {labels[role] || role}
    </span>
  );
}
